/** @file GENERATED by pnpm gen; do not edit. */
import { bindings as e0 } from './api/history/bindings';
import { bindings as e1 } from './panels/assets/bindings';
import { bindings as e2 } from './panels/curves/bindings';
import { bindings as e3 } from './panels/export/bindings';
import { bindings as e4 } from './panels/hierarchy/bindings';
import { bindings as e5 } from './panels/timeline/bindings';
import { bindings as e6 } from './panels/viewport/bindings';
import { bindings as e7 } from './shell/shortcuts/bindings';
export const BINDINGS = [e0, e1, e2, e3, e4, e5, e6, e7] as const;
